import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "geojsonInput", "filesInput", "geojsonTextarea"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedValue = this.selectTarget.value

    if (selectedValue === 'geojson') {
      this.geojsonInputTarget.style.display = 'block'
      this.filesInputTarget.style.display = 'none'
      this.geojsonTextareaTarget.disabled = false
    } else if (selectedValue === 'files') {
      this.geojsonInputTarget.style.display = 'none'
      this.filesInputTarget.style.display = 'block'
      this.geojsonTextareaTarget.disabled = true
    }
  }
}
